import { render, staticRenderFns } from "./hamtr_baiguullaguud.vue?vue&type=template&id=762bf3ef&scoped=true&"
import script from "./hamtr_baiguullaguud.vue?vue&type=script&lang=js&"
export * from "./hamtr_baiguullaguud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762bf3ef",
  null
  
)

export default component.exports